<ng-template #loader>
  <div
    class="circle circle-1"
    [class.inverse]="inverse"
    [class.large]="large"></div>
  <div
    class="circle circle-2"
    [class.inverse]="inverse"
    [class.large]="large"></div>
  <div
    class="circle circle-3"
    [class.inverse]="inverse"
    [class.large]="large"></div>
</ng-template>

@if (!withLogo) {
  <ng-container *ngTemplateOutlet="loader"></ng-container>
} @else {
  <div class="loader-with-logo">
    <div class="logo">
      <ppl-icon
        [svgIcon]="inverse ? 'logo-' + Identity + '-white' : 'logo-' + Identity + '-blue'"
        width="250px"
        height="100px"></ppl-icon>
    </div>
    <div class="loader">
      <ng-container *ngTemplateOutlet="loader"></ng-container>
    </div>
  </div>
}
